var map = {
	"./1 - Copy.png": 2768,
	"./1.png": 1179,
	"./10.png": 226,
	"./10CC.png": 7684,
	"./10DD.png": 9580,
	"./10HH.png": 931,
	"./10SS.png": 5666,
	"./11.png": 9061,
	"./12.png": 6852,
	"./13.png": 7873,
	"./2.png": 1279,
	"./2CC.png": 9951,
	"./2DD.png": 3730,
	"./2HH.png": 3927,
	"./2SS.png": 3189,
	"./3.png": 6060,
	"./3CC.png": 9187,
	"./3DD.png": 4013,
	"./3HH.png": 6929,
	"./3SS.png": 934,
	"./4.png": 8419,
	"./4CC.png": 5762,
	"./4DD.png": 1238,
	"./4HH.png": 504,
	"./4SS.png": 3240,
	"./5.png": 5719,
	"./5CC.png": 7618,
	"./5DD.png": 6176,
	"./5HH.png": 329,
	"./5SS.png": 7349,
	"./6.png": 3504,
	"./6CC.png": 7806,
	"./6DD.png": 4024,
	"./6HH.png": 8596,
	"./6SS.png": 2576,
	"./7.png": 1412,
	"./7CC.png": 5501,
	"./7DD.png": 7762,
	"./7HH.png": 3953,
	"./7SS.png": 9173,
	"./8.png": 877,
	"./8CC.png": 4078,
	"./8DD.png": 7179,
	"./8HH.png": 6638,
	"./8SS.png": 7824,
	"./9.png": 5145,
	"./9CC.png": 4805,
	"./9DD.png": 5607,
	"./9HH.png": 7029,
	"./9SS.png": 3970,
	"./ACC.png": 189,
	"./ADD.png": 237,
	"./AHH.png": 8808,
	"./ASS.png": 2465,
	"./JCC.png": 850,
	"./JDD.png": 5834,
	"./JHH.png": 783,
	"./JSS.png": 6777,
	"./KCC.png": 8119,
	"./KDD.png": 1515,
	"./KHH.png": 2640,
	"./KSS.png": 9599,
	"./QCC.png": 3848,
	"./QDD.png": 9543,
	"./QHH.png": 1901,
	"./QSS.png": 1136,
	"./club.png": 7282,
	"./diamond.png": 4120,
	"./heart.png": 5005,
	"./spade.png": 6195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3034;